import ApiError from './ApiError';

class UnauthorizedError extends ApiError {
  constructor(message?: string) {
    super(message || 'Unauthorized', 403);
    this.name = 'Unauthorized';
  }
}

export default UnauthorizedError;
